import SkipNavigation from './SkipNavigation.component';

export default SkipNavigation;
